import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alm-items-count-wrapper" }
const _hoisted_2 = { class: "items-value-span" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_ctx.value), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.params?.colDef.field === 'count' ?  _ctx.localizer.Localize('LandscapeManagement_Objects_Text') :  _ctx.localizer.Localize('LandscapeManagement_Tenants_Text')), 1)
    ])
  ]))
}